module.exports = __webpack_public_path__ + "img/virtual.e74d4878.jpg";